/** Задача L1: общее форматирование ETA/elapsed для панели обработки и строки списка. */

type Translate = (key: string, opts?: Record<string, unknown>) => string;

/** Секунды -> «< 1 мин» либо «N мин» (округление до минуты, см. processing-panel/row-progress). */
export function formatMinutesLabel(seconds: number, t: Translate): string {
  if (seconds < 60) {
    return t('processing.less-than-minute');
  }
  return t('processing.minutes', { count: Math.round(seconds / 60) });
}

/** ETA-текст с учётом null (ещё «оцениваем...», см. backend meeting_progress_eta). */
export function formatEtaLabel(etaSec: number | null | undefined, t: Translate): string {
  if (etaSec == null) {
    return t('processing.estimating');
  }
  return formatMinutesLabel(etaSec, t);
}
